var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { CanvasToolbar } from '../canvas-toolbar';
import { useConfig, CANVAS_SCALE_TOOLBAR_CONFIG } from './config';
var CanvasScaleToolbar = function (props) {
    var config = useConfig(props);
    return (React.createElement(CanvasToolbar, __assign({ layout: "vertical" }, props, { config: config, position: props.position || { top: 12, right: 12 } })));
};
export { CanvasScaleToolbar, CANVAS_SCALE_TOOLBAR_CONFIG };
